import { type LabelVisibility } from "@common/contexts/FormStyle";
import HelpIcon from "@common/controls/Icon/Help/component";
import { pickFontValues } from "@common/lib/css";
import React from "react";
import { type Padding } from "./lib";

export type FormFieldLabelProps = {
  addon?: any;
  isRequired?: boolean;
  label: string;
  name?: string;
  innerStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  tooltip?: string | null;
};
export const FormFieldLabel = React.forwardRef(
  (props: FormFieldLabelProps, ref: React.ForwardedRef<HTMLLabelElement>) => (
    <div className="label-top single-line-ellipsis" style={props.style}>
      <label ref={ref} className="control-label" style={props.innerStyle}>
        {props.label}
        {!!props.label && props.isRequired ? ` *` : null}
        {!!props.tooltip && <HelpIcon tooltip={props.tooltip} name={props.name} />}
      </label>

      {!!props.addon && <span className="addon">{props.addon}</span>}
    </div>
  )
);
export default FormFieldLabel;

export type FormFieldLabelType = "small_label" | "hidden_label";
type FormFieldInsideLabelProps = Omit<FormFieldLabelProps, "innerStyle" | "style"> & {
  fieldStyle: React.CSSProperties | undefined;
  labelVisibility: LabelVisibility;
  padding?: Padding;
};
export const FormFieldInsideLabel = ({ fieldStyle, labelVisibility, padding, ...props }: FormFieldInsideLabelProps) => {
  const innerStyle = React.useMemo((): React.CSSProperties | undefined => {
    switch (labelVisibility) {
      case "edge": {
        return {
          backgroundColor: fieldStyle?.backgroundColor ?? "#fff",
          borderRadius: fieldStyle?.borderRadius,
          color: "inherit",
          padding: "0px 6px"
        };
      }
    }
  }, [fieldStyle?.backgroundColor, fieldStyle?.borderColor, fieldStyle?.borderRadius, labelVisibility]);

  const style = React.useMemo((): React.CSSProperties | undefined => {
    const style: React.CSSProperties = fieldStyle ? pickFontValues(fieldStyle) : {};

    switch (labelVisibility) {
      case "edge": {
        return {
          ...style,
          display: "flex-inline",
          fontSize: `calc(${style.fontSize ?? "1em"} * 0.8)`,
          lineHeight: "1.2em",
          marginLeft: "6px",
          marginTop: `-0.6em`,
          position: "absolute",
          width: "fit-content"
        };
      }
      case "placeholder":
        return {
          ...style,
          ...padding
        };
      case "small":
        return {
          ...style,
          ...padding,
          paddingBottom: 0,
          fontSize: `calc(${style.fontSize ?? "1em"} * 0.8)`,
          lineHeight: "1.2em"
        };
    }
  }, [fieldStyle, labelVisibility, padding]);

  return <FormFieldLabel {...props} innerStyle={innerStyle} isRequired={props.isRequired} style={style} />;
};
